import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';

export default class ErrorContactComponent extends Component {
  <template>
    Water you still doing here? Shorely the navigation links will take you
    where river you want to go! Please <LinksTo @route="contact">contact us</LinksTo>
    if you cannot locate the page you are looking for.
  </template>
}
